// ABOUTME: TanStack Query mutation wrappers for campaign creation and deletion.
// ABOUTME: Provides injectCreateCampaignMutation() and injectDeleteCampaignMutation() following the model/service split pattern.
import {
  injectMutation,
  injectQueryClient,
} from '@tanstack/angular-query-experimental'
import {
  createCampaign,
  deleteCampaign,
  injectCampaignCreation,
  type CreateCampaignPayload,
} from '../services/campaign.service'

export { type CreateCampaignPayload } from '../services/campaign.service'

export function injectCreateCampaignMutation() {
  const authService = injectCampaignCreation()
  const queryClient = injectQueryClient()

  return injectMutation(() => ({
    mutationFn: (payload: CreateCampaignPayload) => {
      return createCampaign(authService, payload)
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: ['campaigns'] })
    },
  }))
}

export function injectDeleteCampaignMutation() {
  const authService = injectCampaignCreation()
  const queryClient = injectQueryClient()

  return injectMutation(() => ({
    mutationFn: (campaignId: number) => {
      return deleteCampaign(authService, campaignId)
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: ['campaigns'] })
    },
  }))
}
